import {convertToInt} from '@utils/helpers';
import {columnObjectAlignCenter} from '@utils/tableHelpers';

export const ApiKeyColumns = {
    'id': {
        label: 'ID',
        sorting: (row) => convertToInt(row.id),
        header: {
            align: 'center',
            isCollapsed: true,
        },
        content: {
            align: 'center',
        },
    },
    'environment': {label: 'Environment', sorting: (row) => row?.environment?.id ?? null},
    'api_key': {label: 'API key', sorting: true},
    'description': {label: 'Description', sorting: true},
    'creation_datetime': {
        label: 'Generation time',
        sorting: true,
        ...columnObjectAlignCenter,
    },
    'creation_user': {label: 'Generated by', sorting: (row) => row?.creation_user?.name ?? null},
    'actions': {
        label: 'Actions',
        header: {
            align: 'center',
            isCollapsed: true,
        },
        content: {
            align: 'center',
        },
    },
};
